import { connect } from 'react-redux';

import { StoreState } from '../../reducers';
import DownloadStatus from '../../components/ListItem/DownloadStatus';
import DownloadManagerUtils from '../../utils/downloadManager';

interface DownloadStatusOwnProps {
	id?: number;
}

const mapStateToProps = (state: StoreState, { id }: DownloadStatusOwnProps) => {
	const { downloadManager, driveList } = state;

	let isUpToDate = false;
	let isUpdatable = false;

	if (id) {
		const driveItem = driveList.driveItems[id];
		const isDownloaded = DownloadManagerUtils.isItemPersistentlyDownloaded(downloadManager, id);

		if (isDownloaded) {
			const downloadedItem = downloadManager.items[id];
			isUpToDate = DownloadManagerUtils.isLatestVersion(driveItem.version, downloadedItem.version);
			isUpdatable = !isUpToDate;
		}
	}

	return {
		isUpToDate,
		isUpdatable,
	};
};

export default connect(mapStateToProps)(DownloadStatus);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/CoverFlow/DownloadStatus.tsx